import "./Guidance.module.css";
import Header from "@/reusable_sections/Header";
import Process from "./sections/Process";
import Questions from "./sections/Questions";
import Resources from "./sections/Resources";
import Footer from "@/reusable_sections/Footer";
export default function GuidancePage() {
  return <div>
      <Header />
      <Process />
      <Questions />
      <Resources />
      <Footer />
    </div>;
}